import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RenderingTile from 'components/molecules/RenderingTile';

class TileWithValidation extends Component {
    render() {
        const { hasData, innerProps, height = '400px' } = this.props;
        const validator = innerProps.validation.validator;

        let renderCheck = hasData;
        if (renderCheck) {
            renderCheck = validator(innerProps);
        }

        return renderCheck === true ? (
            <this.props.innerComponent {...innerProps} />
        ) : (
            <RenderingTile height={height} title={innerProps.title} show={renderCheck} />
        );
    }
}

TileWithValidation.propTypes = {
    hasData: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.object // null is a default state for Object in PropTypes
    ]),
    innerComponent: PropTypes.any.isRequired,
    innerProps: PropTypes.object.isRequired,
    height: PropTypes.string
};

export default TileWithValidation;



// WEBPACK FOOTER //
// ./src/components/molecules/TileWithValidation.js